
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
  padding-bottom: 60px;
  flex-direction: column;

  .ant-card-body {
    padding: 78px;
    @media (max-width: 1079.98px) {
      padding: 64px;
    }
    @media (max-width: 903.98px) {
      padding: 48px;
    }
    @media (max-width: 730px) {
      padding: 24px;
    }
  }

  img {
    border-radius: 10px !important;
    max-width: 100%;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: Poppins;
    font-weight: 400;
    line-height: 1.25em;
  }
  h1 {
    font-size: 38px;
    line-height: 53.2px;
    font-weight: bold;
    margin-bottom: 36px;
    @media (max-width: 903.98px) {
      font-size: 32px;
    }
  }
  h2 {
    font-size: 28px;
    margin-bottom: 28px;
    margin-top: 84px;
    @media (max-width: 903.98px) {
      font-size: 20px;
    }
  }
  p,
  li {
    font-size: 20px;
    @media (max-width: 903.98px) {
      font-size: 18px;
    }
  }
  .ant-card {
    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  }
`

export const Content = styled.div`
  p,
  li {
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0px;
  }
`

export default Wrapper


    export async function getStaticProps(ctx) {
        
        
        return {
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/p/contracts.style',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  